import type { NavigationGuard } from "vue-router";

import { useDictionariesStore, useDictionaryGroupsStore, useFavoriteDictionariesStore } from "@/stores";

export function fetchSearchDataGuard(): NavigationGuard {
  return async (to, from, next) => {
    const promises = [];

    const dictionaryGroupsStore = useDictionaryGroupsStore();
    if (dictionaryGroupsStore.status == "initial") {
      promises.push(dictionaryGroupsStore.fetch());
    }

    const dictionariesStore = useDictionariesStore();
    if (dictionariesStore.status === "initial") {
      promises.push(dictionariesStore.fetch());
    }

    const favoriteDictionariesStore = useFavoriteDictionariesStore();
    if (favoriteDictionariesStore.status === "initial") {
      promises.push(favoriteDictionariesStore.fetch());
    }

    await Promise.allSettled(promises);

    next();
  };
}
